import { Controller } from "@hotwired/stimulus"
import { ImageHelper } from "../../helpers/ImageHeper"

export default class extends Controller {
  connect() {
    const { cameraId } = this.element.dataset;
    ImageHelper.fetchLiveImage(cameraId, this.element)
  }
}
